import { ScreenBase } from "@frui.ts/screens";
import { Container, interfaces } from "inversify";
import { IInitializationService } from "../services/initialization/types";
import makeWidget from "../views/makeWidget";
import RootViewModel from "./rootViewModel";

function initView(types: interfaces.ServiceIdentifier<ScreenBase>[]) {
  return async (container: Container) => {
    const displayViewModel = container.get<ReturnType<typeof RootViewModel.Factory>>(RootViewModel.Factory)(types);

    return displayViewModel;
  };
}

export default function makeWidgetFor(
  identifier: string,
  types: interfaces.ServiceIdentifier<ScreenBase>[],
  initializationService: interfaces.ServiceIdentifier<IInitializationService>
) {
  return makeWidget(identifier, initView(types), initializationService);
}
